import React, { Component } from "react";
import { NavBar, SideBar, Footer, TitleAndDescription } from "../../components";
import PouchDB from "pouchdb";
import axios from "axios";
//import PouchdbFind from "pouchdb-find";
import "react-toastify/dist/ReactToastify.css";
import InfiniteScroll from "react-infinite-scroll-component";
import { ToastContainer, toast } from "react-toastify";
//import produtoModel from "../../models/produto";
//import Switch from "react-switch";
const { formatarReal } = require("../../utils");
//PouchDB.plugin(PouchdbFind);

export default class ProdutoDestaque extends Component {
  constructor(props) {
    super(props);
    this.load = this.load.bind(this);
    this.abrirProdutoDetalhe = this.abrirProdutoDetalhe.bind(this);

    this.state = {
      produtos: [],
      skip: 0,
      hasMore: true,
      db: null,
      exibirLoading: false,
    };
  }

  async componentDidMount() {
    await this.load();
    /* let db = await new PouchDB("fechoo");
    await this.setState(
      {
        db: db,
      },
      async () => {
        await this.load();
      }
    );*/
  }

  async load() {
    let produtosBusca = [];
    let obj = {
      innerWidth: window.innerWidth,
      skip: this.state.skip,
    };
    await axios
      .post(
        `${this.props.getBaseUrlApi()}/produtosDestaque`,
        obj,
        this.props.parameters()
      )
      .then((response) => {
        produtosBusca = response.data;
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
        }
      });
    for (let produto of produtosBusca) {
      produto.preco.precoUnitComImpostosFinal =
        produto.preco.precoUnitComImpostos;
    }

    if (produtosBusca.length) {
      this.setState((prevState) => ({
        produtos: [...this.state.produtos, ...produtosBusca],
        skip: prevState.skip + 25,
        exibirLoading: false,
      }));
    } else {
      this.setState({ hasMore: false, exibirLoading: false });
    }
    /* this.setState({ exibirLoading: true }, async () => {
      let produtosBusca = [];

      produtosBusca = await produtoModel.findAllDestaque(
        this.state.db,
        this.state.skip
      );

      for (let produto of produtosBusca) {
        produto.preco.precoUnitComImpostosFinal =
          produto.preco.precoUnitComImpostos;
      }

      if (produtosBusca.length) {
        this.setState((prevState) => ({
          produtos: [...this.state.produtos, ...produtosBusca],
          skip: prevState.skip + 25,
          exibirLoading: false,
        }));
      } else {
        this.setState({ hasMore: false, exibirLoading: false });
      }
    });*/
  }

  notificar(type, message) {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }

  abrirProdutoDetalhe(idProduto, precoItem) {
    localStorage.setItem("precoItemCarrinho", precoItem);
    this.props.history.push(
      `/produtos/destaque-detalhe?id=${idProduto}&tipo=produtoDestaque`
    );
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <div className="container-scroller font-app">
          <NavBar title="Produtos em destaque" />
          <div className="container-fluid page-body-wrapper">
            <SideBar itemActive={"produtoDestaque"} />
            <div className="main-panel">
              <div className="content-wrapper">
                {/* <TitleAndDescription
                  title="Produtos em destaque"
                  description="Mostra os produtos em destaque"
                /> */}
                <React.Fragment>
                  <div className="container-filtros-produtos d-flex">
                    <div className="content-filtros-produtos d-flex">
                      {/*<div className="col-12 no-padding">
                      <div className="item-switch-produtos-destaque float-left">
                        <Switch
                          checked={true}
                          //onChange={onChange}
                          onColor="#f0e8fc"
                          onHandleColor="#7c3e7a"
                          handleDiameter={25}
                          uncheckedIcon={false}
                          checkedIcon={false}
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                          height={16}
                          width={48}
                        />
                      </div>
                      <div className="item-descricao-switch float-left">Novos</div>
                    </div>*/}

                      {/* <div className="col-6 no-padding">
                      <div className="item-switch-produtos-destaque float-left">
                        <Switch
                          checked={true}
                          //onChange={onChange}
                          onColor="#f0e8fc"
                          onHandleColor="#7c3e7a"
                          handleDiameter={25}
                          uncheckedIcon={false}
                          checkedIcon={false}
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                          height={16}
                          width={48}
                        />
                      </div>
                      <div className="item-descricao-switch float-left">Promocionais</div>
                    </div> */}
                    </div>
                  </div>

                  <div
                    className="container-itens"
                    style={{
                      float: "left",
                      width: "100%",
                      paddingBottom: "65px",
                      backgroundColor: this.state.produtos.length
                        ? "rgb(217, 217, 217)"
                        : "white",
                    }}
                  >
                    <div className="container card">
                      <InfiniteScroll
                        dataLength={this.state.produtos.length}
                        next={() => this.load(false, true)}
                        hasMore={this.state.hasMore}
                        scrollThreshold={0.4}
                      >
                        {this.state.produtos.map((produto, index) => {
                          return (
                            <React.Fragment key={index}>
                              <div
                                className="item-lista-adicionar d-flex flex-wrap"
                                id={`produtof-${produto._id}`}
                              >
                                <div
                                  className="col-3 no-padding"
                                  style={{ borderBottom: "1px solid #e2e2e2" }}
                                >
                                  <div
                                    className="float-left width-100 text-center"
                                    style={{ padding: "3px" }}
                                  >
                                    {produto.isNovo && (
                                      <div className="label-produto-novo">
                                        NOVO
                                      </div>
                                    )}

                                    {!produto.isNovo &&
                                      produto.preco.isPromo && (
                                        <div className="label-produto-promo">
                                          PROMO
                                        </div>
                                      )}

                                    <img
                                      className="img-responsive"
                                      src={produto.imagemPrincipal}
                                      alt={produto.desc}
                                      style={{
                                        width: "100%",
                                        cursor: "pointer",
                                        maxWidth: "90px",
                                        width: "100%",
                                      }}
                                      onClick={(e) =>
                                        this.abrirProdutoDetalhe(
                                          produto._id,
                                          produto.preco
                                            .precoUnitComImpostosFinal
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                                <div
                                  className="col-9 no-padding"
                                  style={{
                                    borderBottom: "1px solid #e2e2e2",
                                    borderRight: "1px solid #e2e2e2",
                                  }}
                                >
                                  <div
                                    className="float-left width-100 font-13"
                                    style={{
                                      fontWeight: "bold",
                                      color: "#5f9f1a",
                                      cursor: "pointer",
                                    }}
                                    onClick={(e) =>
                                      this.abrirProdutoDetalhe(
                                        produto._id,
                                        produto.preco.precoUnitComImpostosFinal
                                      )
                                    }
                                  >
                                    # {produto.cod}&nbsp;&nbsp;
                                    <span style={{ position: "relative" }}>
                                      <i
                                        className="fa fa-circle"
                                        style={{ color: produto.giro.legenda }}
                                      ></i>
                                      <span className="icone-info">i</span>
                                    </span>
                                    &nbsp;
                                    {produto.preco.isPromo && (
                                      <span>
                                        <img
                                          src="../images/exclamation.png"
                                          style={{ width: "17px" }}
                                          alt="Promoção"
                                        />
                                      </span>
                                    )}
                                  </div>

                                  <div
                                    className="float-left width-100 font-13"
                                    style={{ cursor: "pointer" }}
                                    onClick={(e) =>
                                      this.abrirProdutoDetalhe(
                                        produto._id,
                                        produto.preco.precoUnitComImpostosFinal
                                      )
                                    }
                                  >
                                    {produto.desc}
                                  </div>

                                  <div
                                    className="float-left width-100 font-size-11 d-flex"
                                    style={{
                                      paddingTop: "10px",
                                      paddingBottom: "5px",
                                    }}
                                  >
                                    <div className="col-6">
                                      Estoque&nbsp;
                                      <span
                                        className={`${
                                          produto.estoque.qtd === 0
                                            ? "estoque-indisponivel"
                                            : ""
                                        }`}
                                      >
                                        {produto.estoque.qtd} {produto.unid}
                                      </span>
                                    </div>

                                    <div className="col-6 text-right">
                                      Embalagem {produto.preco.embPadrao}{" "}
                                      {produto.unid}
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="float-left width-100"
                                  style={{ height: "5px" }}
                                ></div>

                                <div className="col-1 no-padding"></div>

                                <div
                                  className="col-3 no-padding text-center"
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <div
                                    className="float-left width-100 font-size-11"
                                    style={{ padding: "0 5px" }}
                                  >
                                    Preço Padrão{" "}
                                    <span className="display-block">
                                      R${" "}
                                      {formatarReal(
                                        produto.preco.precoUnitComImpostos
                                      )}
                                    </span>
                                  </div>
                                </div>
                                <div
                                  className="col-8 no-padding d-flex"
                                  style={{ alignItems: "center" }}
                                >
                                  <div className="col-5 no-padding float-left">
                                    <div className="float-left width-100 font-13 text-right">
                                      Preço R$:
                                    </div>
                                  </div>

                                  <div className="col-7 no-padding float-left pd-left-7">
                                    <div className="float-left width-100">
                                      <input
                                        type="text"
                                        value={formatarReal(
                                          produto.preco
                                            .precoUnitComImpostosFinal
                                        )}
                                        className={"form-control teste20"}
                                        disabled={true}
                                      />
                                    </div>
                                  </div>
                                </div>

                                {index < this.state.produtos.length - 1 && (
                                  <div
                                    className="float-left width-100"
                                    style={{
                                      height: "1px",
                                      backgroundColor: "#d9d9d9",
                                      marginTop: "10px",
                                    }}
                                  ></div>
                                )}
                              </div>
                            </React.Fragment>
                          );
                        })}

                        {this.state.exibirLoading && (
                          <div className="div-loading">
                            <div id="loading-bar-spinner" className="spinner">
                              <div className="spinner-icon"></div>
                            </div>
                          </div>
                        )}
                      </InfiniteScroll>
                    </div>
                  </div>
                </React.Fragment>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
